import i18n from "@/i18n";
import requireAuthorization from "@/routes/helper/requireAuthorization";
import { PermitionEnum } from "@/components/security/Permitions";

export default [
    {
        path: "/channels",
        name: "channels",
        component: () => import("@/components/channels/_Channels.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            permission: PermitionEnum.ViewChannelsUI,
            breadcrumbs: {
                icon: "channels-icon",
                paths: []
            },
            title: "navbar.channels"
        }
    },
    {
        path: "/channel/:channelId/update",
        name: "updatechannel",
        component: () => import("@/components/channels/_ChannelForm.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            permission: PermitionEnum.UpdateChannel,
            breadcrumbs: {
                icon: "channels-icon",
                paths: [
                    ["/channels", i18n.t("channels.title")]
                ]
            }
        },
        props: true
    },
    {
        path: "/channel/new",
        name: "newchannel",
        component: () => import("@/components/channels/_ChannelForm.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            permission: PermitionEnum.CreateChannel,
            breadcrumbs: {
                icon: "channels-icon",
                paths: [
                    ["/channels", i18n.t("channels.title")]
                ]
            },
            title: "channels.createTitle"
        },
        props: true
    },
    {
        path: "/channel/:channelId/post/:postType/createpost",
        name: "createPost",
        component: () => import("@/components/posts/_PostForm.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            permission: PermitionEnum.CreatePost,
            breadcrumbs: {
                icon: "channels-icon",
                paths: [
                    ["/channels", i18n.t("channels.title")],
                    ["/channel/:channelId/update", ":channelName"]
                ]
            },
            title: "posts.newPost"
        },
        props: true
    },
    {
        path: "/channel/:channelId/post/:postType/editorcreatepost",
        name: "editorCreatePost",
        component: () => import("@/components/posts/_PostForm.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            permission: PermitionEnum.CreatePost,
            breadcrumbs: {
                icon: "channels-icon",
                paths: [
                    ["/channels", i18n.t("channels.title")],
                    ["/channel/:channelId/editorupdate", ":channelName"]
                ]
            },
            title: "posts.newPost"
        },
        props: true
    },
    {
        path: "/channel/:channelId/updatePost/:postId",
        name: "updatePost",
        component: () => import("@/components/posts/_PostForm.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            permission: PermitionEnum.UpdatePost,
            breadcrumbs: {
                icon: "channels-icon",
                paths: [
                    ["/channels", i18n.t("channels.title")],
                    ["/channel/:channelId/update", ":channelName"]
                ]
            }
        },
        props: true
    },
    {
        path: "/channel/:channelId/editorupdatePost/:postId",
        name: "editorUpdatePost",
        component: () => import("@/components/posts/_PostForm.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            permission: PermitionEnum.UpdatePost,
            breadcrumbs: {
                icon: "channels-icon",
                paths: [
                    ["/channels", i18n.t("channels.title")],
                    ["/channel/:channelId/editorupdate", ":channelName"]
                ]
            }
        },
        props: true
    },
    {
        path: "/channel/:channelId/preview",
        name: "channelPreview",
        component: () => import("@/components/channels/_ChannelPreview.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            permission: PermitionEnum.ViewChannelsUI,
            layout: () => import("@/components/layouts/_BasicLayout.vue"),
            title: "common.preview"
        },
        props: true
    },
    {
        path: "/channel/:channelId/editorupdate",
        name: "editorupdatechannel",
        component: () => import("@/components/channels/_ChannelFormEditor.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            permission: PermitionEnum.ViewChannelsUI,
            breadcrumbs: {
                icon: "channels-icon",
                paths: [
                    ["/channels", i18n.t("channels.title")]
                ]
            }
        },
        props: true
    }
];
